<template>
  <van-tabbar v-model="active" safe-area-inset-bottom route>
    <van-tabbar-item
      icon="fire-o"
      replace
      :to="discovery"
    >发现</van-tabbar-item>
    <van-tabbar-item
      icon="goods-collect-o"
      :dot="false"
      replace
      :to="purchased"
    >已购</van-tabbar-item>
    <van-tabbar-item
      icon="contact"
      :dot="false"
      replace
      :to="personal"
    >个人</van-tabbar-item>
  </van-tabbar>
</template>

<script>
  import Vue from 'vue'
  import { Tabbar, TabbarItem } from 'vant'
  Vue.use(Tabbar).use(TabbarItem)
  export default {
    props: {
      slug: String
    },
    data () {
      return {
        active: 0
      }
    },
    watch: {
    },
    computed: {
      discovery () {
        let to = {
          name: `Discovery`,
          params: { slug: this.slug }
        }
        return to
      },
      purchased () {
        let to = {
          name: `Purchased`,
          params: { slug: this.slug }
        }
        return to
      },
      personal () {
        let to = {
          name: `PersonalIndex`,
          params: { slug: this.slug }
        }
        return to
      }
    },
    methods: {
    }
  }
</script>

<style lang="css" scoped>
</style>
